var index = "";
export { index as default };
